import { createContactsData } from '../models/contacts-data.model';
import { createContactDetails } from '../models/contact-details.model';
import { createGridLayout, createGridItem } from '../../../store/global/gridlayout';
import { contactGroupStates } from "./groups/state";
import { contactFileStates } from "./files/state";

export const state = {
  contactsData: createContactsData({}),
  // contactListStartRow: 0,
  selectedContact: createContactDetails({}),

  searchConfig: {},

  selectedContactLoading: false,
  accountingInfo: {},
  contactDetails: [],
  // contactDetailsGrid: createGridLayout({
  //   layout: [
  //     createGridItem({
  //       x: 0,
  //       y: 0,
  //       w: 30,
  //       h: 25,
  //       i: 'contact',
  //     }),
  //     createGridItem({
  //       x: 30,
  //       y: 0,
  //       w: 30,
  //       h: 25,
  //       i: 'related_contacts',
  //     }),
  //   ]
  // })


  ...contactGroupStates,
  ...contactFileStates,
};
